var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmingLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_radial_8881_1079)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8881_1079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint1_radial_8881_1079)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8881_1079)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_d_8881_1079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0353 19.2354C15.0706 9.98944 0 12.1231 0 12.1231C0 12.1231 0.494117 30.615 14.5765 27.7701C13.5882 20.8949 9.88235 18.9983 9.88235 18.9983C16.8 18.9983 17.2941 27.0588 17.2941 27.0588L17.1167 41H22.2932L22.2353 28.0071C22.2353 28.0071 22.2353 18.7612 29.6471 16.3905C29.6471 16.3905 24.7059 23.5027 24.7059 28.2442C42 29.9037 42 7.14454 42 7.14454C42 7.14454 20.0118 4.77379 18.0353 19.2354Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8881_1079",
    x: 0,
    y: 7,
    width: 42.575,
    height: 34.575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.575022,
    dy: 0.575022
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8881_1079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8881_1079",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8881_1079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5 40) rotate(-90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2F739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#3CFF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#279A3A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8881_1079",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5 44) rotate(-90) scale(28.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2F739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279A3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmingLogoNew);
export default __webpack_public_path__ + "static/media/farming_logo_new.ec92745cda7ebac80af3644f3123d76a.svg";
export { ForwardRef as ReactComponent };